import React from 'react'
import { useTranslation } from 'lib/i18n'

import Typography from 'components/UI/Typography/Typography'

import styles from './AverageRating.module.css'

type AverageRatingProps = {
  sumOfAllRatings: number
  numberOfRatings: number
}

const AverageRating: React.FC<AverageRatingProps> = ({
  sumOfAllRatings,
  numberOfRatings,
}) => {
  const { t } = useTranslation()

  const average = sumOfAllRatings / numberOfRatings || 0

  return (
    <div className={styles.averageRatingContainer}>
      <div className={styles.averageRatingBox}>
        <Typography.LargeHeading className={styles.averageRating}>
          {average > 0 ? average.toFixed(1) : '-'}
        </Typography.LargeHeading>
        <Typography.BodyBold className={styles.averageRating}>
          {t('Reviews.averageRatingLabel', 'out of 5')}
        </Typography.BodyBold>
      </div>
      <Typography.BodySmall className={styles.label}>
        {t('Reviews.averageRatingTitle', 'Average Rating')}
      </Typography.BodySmall>
    </div>
  )
}

export default AverageRating
